import { PatientType } from '@nkr/enums/index';

export interface IDonorProfileHeaderInfo {
    id: number,
    alias: string,
    isTransplanted: boolean,
    isExportable: boolean,
    isActive: boolean,
    isAdp: boolean,
    creatinineClearance: number,
    positionInSwap: number,

    clusterId: number,
    clusterNumber: number,
    clusterStatusId: number,
    clusterStatus: string,

    chainId: number,
    chainStatusId: number,
    chainStatus: string,

    lastOrderDate: string,
    validationResults: string[],
    dataCompliance: string[],
    canOrderCheekSwab: boolean,
    hasAdpFile: boolean,

    //   pairedRecipientId: number,
    //   pairedRecipientAlias: string,
    //   adpRecipientId: number,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientType: PatientType,
    
    canConvert: boolean,
    canDelete: boolean,
    alleleData: boolean,
    donorCenterId: number,
    donationCenterId: number,
    statusId: number,
    wageAndTravelRequest: boolean,
    registrationId: number,
    requisitionId: number,
    isRequisition: boolean,
    isExpertSystemParticipant: boolean,
    isInExpertSystem: boolean
}